<template lang="html">
  <div>

    <b-row>
      <b-col sm="12">
        <b-card>
          <b-row>
            <b-col style="height:250px">
              <b-row>
                <b-col sm="4">
                  <strong>일 수집 데이터 통계</strong>
                </b-col>
                <b-col sm="8" class="d-flex justify-content-end align-items-center text-right">
                  <b-form-group class="m-0">
                    <b-form-radio-group v-model="dataType">
                      <b-form-radio value="all">전체</b-form-radio>
                      <b-form-radio value="report">리포트</b-form-radio>
                      <b-form-radio value="news">뉴스</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                  <date-picker
                    type="date"
                    range
                    :disabled-date="disabledAfterToday"
                    :editable="false"
                    valueType="format"
                    placeholder="조회기간 입력"
                    format="YYYY-MM-DD"
                    :lang="datepickerLang"
                    v-model="dailyDateRange"
                  />
                </b-col>
              </b-row>
              <div class="amchart_div" ref="dailyChartDiv">
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-card>
          <b-row>
            <b-col sm="12">

              <b-row>
                <b-col sm="8">
                  <strong>사이트별 수집 데이터 통계</strong>
                </b-col>
                <b-col sm="4" class="text-right">
                  <date-picker
                    type="date"
                    range
                    :disabled-date="disabledAfterToday"
                    :editable="false"
                    valueType="format"
                    placeholder="조회기간 입력"
                    format="YYYY-MM-DD"
                    :lang="datepickerLang"
                    v-model="siteDateRange"
                  />
                </b-col>
              </b-row>

              <div style="display: flex; flex-direction: row;">
                <div class="amchart_div_flex">
                  <strong>추가</strong>
                  <div v-show="siteCountDataL.length !== 0" class="amchart_div" ref="siteChartDiv_l">
                  </div>
                  <div v-show="siteCountDataL.length === 0" class="amchart_div amchart_nodata">
                    <div>
                      <strong>데이터 없음</strong>
                    </div>
                  </div>
                </div>

                <div class="amchart_div_flex">
                  <strong>업데이트</strong>
                  <div v-show="siteCountDataR.length !== 0" class="amchart_div" ref="siteChartDiv_r">
                  </div>
                  <div v-show="siteCountDataR.length === 0" class="amchart_div amchart_nodata">
                    <div>
                      <strong>데이터 없음</strong>
                    </div>
                  </div>
                </div>
              </div>

            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import "vue2-datepicker/index.css";
import DatePicker from "vue2-datepicker";
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import * as am5percent from '@amcharts/amcharts5/percent';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import am5themes_Moonrise from '@amcharts/amcharts5/themes/Moonrise'
import * as am5plugins_sliceGrouper from "@amcharts/amcharts5/plugins/sliceGrouper";
import { mainColorGradation } from '../../../../config/amChart/_config';
import _ from 'lodash'

am5.addLicense('AM5C401883821');
let am5_chart={};

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      dataType: 'all',
      dailyDateRange: [],  //일 수집 데이터 통계 선택 날짜
      siteDateRange: [],   //사이트별 수집 데이터 통계 선택 날짜
      datepickerLang: {
        yearFormat: "YYYY년",
        monthFormat: "M월",
        days:["일","월","화","수","목","금","토"]
      },
      queryParams: {
        statistic_type: '',
        start_date: '', //YYYY-MM-DD
        end_date:'',
        ext_report_yn:'Y',
        ext_news_yn:'Y',
      },
      dailyCountData:[],
      siteCountDataL:[],
      siteCountDataR:[],
    }
  },
  mounted: function() {
    this.initData()
  },
  watch: {
    // 차트 데이터 watch
    'dailyCountData'(){
      this.drawDailyCountList()
    },
    'siteCountDataL'(){
      this.drawSiteCountList('siteChartDiv_l', this.siteCountDataL, "add_count");
    },
    'siteCountDataR'(){
      this.drawSiteCountList('siteChartDiv_r', this.siteCountDataR, "mod_count");
    },
    'dataType'(){
      if(this.dataType == 'all'){
        this.queryParams.ext_report_yn = 'Y'
        this.queryParams.ext_news_yn = 'Y'
      } else if(this.dataType == 'report'){
        this.queryParams.ext_report_yn = 'Y'
        this.queryParams.ext_news_yn = 'N'
      }else if(this.dataType == 'news'){
        this.queryParams.ext_report_yn = 'N'
        this.queryParams.ext_news_yn = 'Y'
      }
      this.getStatisticsList('daily');
      this.getStatisticsList('site');
    },
    //date-picker watch
    'dailyDateRange'(){
      this.getStatisticsList('daily');
      this.getStatisticsList('site');
      this.siteDateRange = this.dailyDateRange;
    },
    'siteDateRange'(){
      this.getStatisticsList('site')
    }

  },

  methods: {
    initData() {
      // date-picker에 넣을 날짜 string 생성 및 그래프 차트 생성에 필요한 값 api 조회(watch)
      this.dailyDateRange = [];
      this.dailyDateRange[0] = this.makeDayString(6);
      this.dailyDateRange[1] = this.makeDayString();

      this.siteDateRange = [];
      this.siteDateRange[0] = this.makeDayString(6);
      this.siteDateRange[1] = this.makeDayString();

    },
    //오늘날짜 기준 date string 생성(yyyy-MM-dd)
    makeDayString(dateMinus) {
      let nowDate = new Date();
      if (dateMinus != null) {
        nowDate.setDate(nowDate.getDate() - dateMinus)
      }
      return nowDate.getFullYear() +
        '-' + ((nowDate.getMonth() + 1) <= 9 ? "0" + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)) +
        '-' + ((nowDate.getDate()) <= 9 ? "0" + (nowDate.getDate()) : (nowDate.getDate()));
    },
    //date-picker 미래일자 선택 disable
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today
    },
    //일 수집 차트 생성
    drawDailyCountList() {
      // 차트를 다시 그리는 경우, dispose()를 하여 기존 데이터값을 버린 후 다시 객체를 만들어야함.
      if (am5_chart["am5_countChart"]) {
        am5_chart["am5_countChart"].dispose()
      }
      //차트 객체 생성
      am5_chart["am5_countChart"] = am5.Root.new(this.$refs.dailyChartDiv);
      let am5_countChart = am5_chart["am5_countChart"];

      //애니메이션 추가
      am5_countChart.setThemes([
        am5themes_Animated.new(am5_countChart),
      ]);

      //차트타입(xy차트)
      let chart = am5_countChart.container.children.push(
        am5xy.XYChart.new(am5_countChart, {
          panY: false,
          layout: am5_countChart.verticalLayout
        })
      );

      //  Y축 생성
      let yAxis = chart.yAxes.push(
        am5xy.ValueAxis.new(am5_countChart, {
          renderer: am5xy.AxisRendererY.new(am5_countChart, {})
        })
      );

      // X축 생성
      let xAxis = chart.xAxes.push(
        am5xy.CategoryAxis.new(am5_countChart, {
          renderer: am5xy.AxisRendererX.new(am5_countChart, {
            minorGridEnabled: true,
            minorLabelsEnabled: false
          }),
          categoryField: "date",
          tooltip: am5.Tooltip.new(am5_countChart, {})
        })
      );
      xAxis.data.setAll(this.dailyCountData);

      // 데이터1 생성
      let series1 = chart.series.push(
        am5xy.SmoothedXLineSeries.new(am5_countChart, {
          name: "추가",
          xAxis: xAxis,
          yAxis: yAxis,
          valueYField: "add_count",
          categoryXField: "date",
          stroke: am5.color('#13345A'),
          fill: am5.color('#13345A'),
          tooltip: am5.Tooltip.new(am5_countChart, {
            labelText: "[bold]{name}[/]\n{valueX.formatDate()}{valueY}건"
          }),
          legendLabelText: "[bold {stroke}]{name} [/]",
          stacked: true
        })
      );
      series1.strokes.template.setAll({
        strokeWidth: 1.5
      });

      let upthis = this; // 콜백 안에서 this 호출하는용

      //데이터1값에 점 추가, 클릭시 하단 통계 업데이트
      series1.bullets.push(function() {
        let circle = am5.Circle.new(am5_countChart, {
          radius: 7,
          fill: series1.get("fill"),
          stroke: am5_countChart.interfaceColors.get("background"),
          toggleKey: "active",
        });

        circle.on("active", function(active, target) {
          let tempArr = []
          tempArr[0] = target._dataItem.dataContext.date;
          tempArr[1] = target._dataItem.dataContext.date;
          upthis.siteDateRange = tempArr;
        });

        return am5.Bullet.new(am5_countChart, {
          sprite: circle
        });
      });

      //차트에 데이터1 추가
      series1.data.setAll(this.dailyCountData);

      //데이터2 생성
      let series2 = chart.series.push(
        am5xy.SmoothedXLineSeries.new(am5_countChart, {
          name: "업데이트",
          xAxis: xAxis,
          yAxis: yAxis,
          valueYField: "mod_count",
          categoryXField: "date",
          stroke: am5.color('#5A98E1'),
          fill: am5.color('#5A98E1'),
          tooltip: am5.Tooltip.new(am5_countChart, {
            labelText: "[bold]{name}[/]\n{valueX.formatDate()}{valueY}건",
          }),
          legendLabelText: "[bold {stroke}]{name}[/]",
        })
      );
      series2.strokes.template.setAll({
        strokeWidth: 1.5
      });

      //데이터2에 점 추가, 클릭시 하단 통계 업데이트
      series2.bullets.push(function() {
        var circle = am5.Circle.new(am5_countChart, {
          radius: 7,
          fill: series2.get("fill"),
          stroke: am5_countChart.interfaceColors.get("background"),
          toggleKey: "active",
        });
        circle.on("active", function(active, target) {
          let tempArr = []
          tempArr[0] = target._dataItem.dataContext.date;
          tempArr[1] = target._dataItem.dataContext.date;
          upthis.siteDateRange = tempArr;
        });

        return am5.Bullet.new(am5_countChart, {
          sprite: circle
        });
      });
      //차트에 데이터2 추가
      series2.data.setAll(this.dailyCountData);

      // 범례 추가
      let legend = chart.children.push(am5.Legend.new(am5_countChart, {}));
      legend.data.setAll(chart.series.values);

      // 차트에 마우스 올릴시 동작
      chart.set("cursor", am5xy.XYCursor.new(am5_countChart, {
        xAxis: xAxis
      }));

      //차트 렌더링
      am5_chart["am5_countChart"] = am5_countChart;
    },

    //하단 반원 그래프 생성
    drawSiteCountList(refName, chartData, seriesValue) {
      // 차트를 다시 그리는 경우, dispose()를 하여 값을 버린 후 다시 객체를 만들어야함.
      if (am5_chart[refName]) {
        am5_chart[refName].dispose()
      }

      am5_chart[refName] = am5.Root.new(this.$refs[refName]);
      let am5_siteChart = am5_chart[refName];

      am5_siteChart.setThemes([
        am5themes_Animated.new(am5_siteChart),
        am5themes_Moonrise.new(am5_siteChart)
      ]);

      let chart = am5_siteChart.container.children.push(
        am5percent.PieChart.new(am5_siteChart, {
          startAngle: -180,
          endAngle: 0,
          radius: am5.percent(80),
          layout: am5_siteChart.verticalLayout,
        })
      );

      //차트 데이터 설정
      let series = chart.series.push(
        am5percent.PieSeries.new(am5_siteChart, {
          name: "Series",
          valueField: seriesValue,
          categoryField: "site_name",
          startAngle: -180,
          endAngle: 0,
          position: 'relative',
          //범례설정
          legendLabelText: "[bold {fill}]{category}[/]",
          legendValueText: "[{fill}]{valuePercentTotal.formatNumber('0.0')}%|{value}건[/]",
          innerRadius: am5.percent(50),
          alignLabels: true,
          //내부 pie값 hover시 text
          tooltip: am5.Tooltip.new(am5_siteChart, {
            labelText: "[bold]{site_name}[/] {value}건({valuePercentTotal.formatNumber('0.0')}%)[/]",
          })
        })
      );

      //차트 커스텀 색상 지정
      series.get("colors").set("colors", mainColorGradation);

      //반원 바깥쪽 라벨 텍스트
      series.labels.template.setAll({
        fontSize: 12,
        text:"[bold {fill}]{site_name}[] {value}건({valuePercentTotal.formatNumber('0.0')}%)",
      });

      //차트와 라벨 사이 선
      series.ticks.template.setAll({
        stroke: am5.color(0x333333),
        location:0.97,
        strokeWidth: 2
      });

      //3%이하는 라벨 미표시
      series.labels.template.adapters.add("y", function(y, target) {
        let dataItem = target.dataItem;
        if (dataItem) {
          let tick = dataItem.get("tick");
          if (tick) {
            if (dataItem.get("valuePercentTotal") < 3) {
              target.set("forceHidden", true);
              tick.set("forceHidden", true);
            }
            else {
              target.set("forceHidden", false);
              tick.set("forceHidden", false);
            }
          }
          return y;
        }
      });

      series.data.setAll(chartData);

      //하단 범례 추가설정
      let legend = chart.children.push(
        am5.Legend.new(am5_siteChart, {
          x: am5.percent(50),
          centerX: am5.percent(50),
          alignLabels:true,
          y: am5.percent(65),
          layout: am5.GridLayout.new(am5_siteChart, {
            maxColumns: 3,
            fixedWidthGrid: true,
            //align: "center"
          }),
          height: am5.percent(50),
        }
      ));

      //하단 범례-앞부분 글자(사이트명)
      legend.labels.template.setAll({
        fontSize: 13,
        fontWeight: "300",
        oversizedBehavior: "truncate",
        minWidth: 85,
        maxWidth: 85,
        ellipsis: "..."
      });

      //하단 범례-사이트명 이후 글자(퍼센트, 건수)
      legend.valueLabels.template.setAll({
        fontSize: 12,
        fontWeight: "400",
        minWidth: 65,
      });

      legend.data.setAll(series.dataItems);

      // 데이터 그룹핑
      am5plugins_sliceGrouper.SliceGrouper.new(am5_siteChart, {
        series: series,
        legend: legend,
        clickBehavior: "zoom",
        threshold: 2,
        limit: 11,
      });

      am5_chart[refName] = am5_siteChart;
    },

    //통계 데이터 API 통신
    getStatisticsList(type) {
      let token = sessionStorage.getItem("myToken");
      let queryParamsValue = ''

      let params = _.cloneDeep(this.queryParams);
      params.start_date = this.dailyDateRange[0];
      params.end_date = this.dailyDateRange[1];
      params.statistic_type = type;
      if (params.start_date !== null && params.end_date !== null) {

        let encode_params = encodeURI(JSON.stringify(params));
        let statistic_type = params.statistic_type;
        let data = new FormData();
        data.append('objs', encode_params);

        this.$http
          .post("/select/extReportStaticsInfo?access_token=" + token, data, null)
          .then((result) => {
            if (statistic_type === 'daily') {
              this.dailyCountData = result.data;
              this.drawDailyCountList();
            } else if (statistic_type === 'site') {
              //count 많은 순으로 정렬해서 data()에 저장
              this.siteCountDataL =
                result.data.filter(d => d.add_count > 0)
                  .sort(function(a, b) {
                    return b.add_count - a.add_count;
                  });

              this.siteCountDataR =
                result.data.filter(d => d.mod_count > 0)
                  .sort(function(a, b) {
                    return b.mod_count - a.mod_count;
                  });
            }
          });
      }
    }
  }
}
</script>

<style lang="css" scoped>
.amchart_div {
  width: auto;
  height: 95%;
}
.amchart_div_flex {
  min-width: 50%;
  min-height: 350px;
}
.amchart_nodata{
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/statistics/extsite/ExtSiteStatistics.vue